import * as Yup from "yup";

export const nameValidation = Yup.string()
  .trim()
  .required("Name is required")
  .min(3, "Name must be at least 3 characters")
  .max(100, "Name cannot exceed 100 characters");

export const phoneValidation = Yup.string()
  .trim()
  .required("Mobile number is required")
  .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
  .matches(/^[6-9]/, "Mobile number must start with 6, 7, 8, or 9")
  .matches(/^(?!([0-9])\1{9})/, "Mobile number cannot be all same digits");

export const strongPasswordValidation = Yup.string()
  .required("Password is required")
  .min(8, "Password must be at least 8 chars")
  .matches(/[A-Z]/, "Password must contain an uppercase letter")
  .matches(/[a-z]/, "Password must contain a lowercase letter")
  .matches(/[0-9]/, "Password must contain a number")
  .matches(/[^A-Za-z0-9]/, "Password must contain a special character");

export const loginPasswordValidation = Yup.string()
  .required("Password is required")
  .min(6, "Password must be at least 6 chars");

export const confirmPasswordValidation = (refField) => Yup.string()
  .required("Please confirm password")
  .oneOf([Yup.ref(refField), null], "Passwords do not match");

// --- Onboarding & Business Validations ---

export const businessNameValidation = Yup.string()
  .trim()
  .required("Business Name is required")
  .max(100, "Business Name cannot exceed 100 characters");

export const businessCategoryValidation = Yup.string()
  .required("Category is required")
  .notOneOf(["Select Category"], "Category is required");

export const productsServicesValidation = Yup.array()
  .of(Yup.string())
  .min(1, "At least one product/service is required");

export const aboutBusinessValidation = Yup.string()
  .trim()
  .required("About Business is required")
  .max(500, "About Business cannot exceed 500 characters");

export const yearEstablishedValidation = Yup.number()
  .nullable()
  .max(new Date().getFullYear(), "Year cannot be in the future");

export const websiteValidation = Yup.string()
  .nullable()
  .matches(
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/,
    { message: "Invalid website URL", excludeEmptyString: true }
  );

export const addressLineValidation = Yup.string()
  .trim()
  .required("Address Line 1 is required");

export const cityValidation = Yup.string()
  .trim()
  .required("City is required");

export const stateValidation = Yup.string()
  .required("State is required");

export const pinCodeValidation = Yup.string()
  .trim()
  .required("PIN Code is required")
  .matches(/^\d{6}$/, "PIN Code must be exactly 6 digits");

export const gstValidation = Yup.string()
  .trim()
  .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, "Invalid GST Number format");

export const panValidation = Yup.string()
  .trim()
  .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN Number format");

